import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "hub-shares-info-list-data-table-wrapper" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_HubSharesListTableRow = _resolveComponent("HubSharesListTableRow");
    const _component_v_data_table_virtual = _resolveComponent("v-data-table-virtual");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_data_table_virtual, {
            hover: "",
            density: "compact",
            "item-height": "37",
            class: "hub-shares-info-list-data-table brg-table",
            "hide-default-footer": "",
            "must-sort": "",
            "fixed-header": "",
            "no-data-text": _ctx.localeInfo.noDataText,
            items: _ctx.getterShareInfoList,
            headers: _ctx.hubSharesListTableHeader,
            "items-per-page": -1,
            "header-props": { style: 'padding: 0 8px' },
            "sort-by": _ctx.sortBy,
            "onUpdate:sortBy": _ctx.handleUpdateSortBy
        }, {
            bottom: _withCtx(() => _cache[0] || (_cache[0] = [])),
            [`item`]: _withCtx(({ item }) => [
                _createVNode(_component_HubSharesListTableRow, {
                    item: item,
                    "handle-click-row": _ctx.handleClickRow
                }, null, 8 /* PROPS */, ["item", "handle-click-row"])
            ]),
            _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["no-data-text", "items", "headers", "sort-by", "onUpdate:sortBy"])
    ]));
}
